class NotificationSoundService {
  constructor() {
    this.sounds = {
      achievement: new Audio('/sounds/achievement.mp3'),
      badge: new Audio('/sounds/badge.mp3'),
      title: new Audio('/sounds/title.mp3'),
      message: new Audio('/sounds/message.mp3'),
      like: new Audio('/sounds/like.mp3'),
      default: new Audio('/sounds/default.mp3')
    };
    
    // Preload all sounds
    Object.values(this.sounds).forEach(audio => {
      audio.preload = 'auto';
      audio.volume = this.getVolume();
    });
  }

  play(type = 'default') {
    if (!this.isEnabled()) return;
    
    const sound = this.sounds[type] || this.sounds.default;
    sound.currentTime = 0; // Reset to start
    sound.play().catch(err => console.log('Sound play failed:', err));
  }

  isEnabled() {
    return localStorage.getItem('notificationSoundEnabled') !== 'false';
  }

  setEnabled(enabled) {
    localStorage.setItem('notificationSoundEnabled', enabled);
  }

  getVolume() {
    return parseFloat(localStorage.getItem('notificationVolume') || '0.5');
  }

  setVolume(volume) {
    const vol = Math.max(0, Math.min(1, volume));
    localStorage.setItem('notificationVolume', vol);
    Object.values(this.sounds).forEach(audio => {
      audio.volume = vol;
    });
  }
}

export default new NotificationSoundService();
